import {
   AppointmentAlreadyCancelledFault,
   Visit,
   VisitAlreadyStartedFault,
   VisitAndAppointmentView,
   VisitStartCommand,
} from '@dreryk/egabinet-visit-frontend-api';
import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarInformativeEvent, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitTranslationKeys } from '../../../translations';

type VisitStartCommandParameters = {
   appointmentId: VisitAndAppointmentView['appointmentId'];
};

type VisitStartCommandOptions = {
   confidentialityLevel: ConfidentialityLevel;
   onVisitAlreadyStartedFault: VoidFunction;
   onAppointmentAlreadyCancelledFault: VoidFunction;
   visitType?: visitPaths.VisitType;
};

export const useVisitStartCommand = (
   options: VisitStartCommandOptions
): UseCqrsCommandResult<
   Visit['id'],
   VisitStartCommandParameters,
   VisitAlreadyStartedFault | AppointmentAlreadyCancelledFault
> => {
   const push = useHistoryPushWithBackAction(true);

   return useCqrsCommand(
      (parameters) => {
         const command = new VisitStartCommand();
         command.appointmentId = parameters.appointmentId;
         command.confidentialityLevel = options.confidentialityLevel;
         return command;
      },
      {
         onSuccess: (visitId) => {
            push(visitPaths.getVisitEntryPath(visitId, options.visitType), {});
         },
         onFault: {
            'egabinet-visit-frontend-api:VisitAlreadyStartedFault': () => {
               dispatchSnackbarInformativeEvent(visitTranslationKeys.alreadyStarted);
               options.onVisitAlreadyStartedFault();
            },
            'egabinet-visit-frontend-api:AppointmentAlreadyCancelledFault': () => {
               dispatchSnackbarInformativeEvent(visitTranslationKeys.alreadyCancelled);
               options.onAppointmentAlreadyCancelledFault();
            },
         },
      }
   );
};
